/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import Delay from "components/Delay/Delay";
import CircularProgress from "components/Progress/CircularProgress";

const useClasses = makeStyles(() => ({
    fullScreen: {
        display: "flex",
        alignItems: "center",
        height: "100vh",
    },
}));

interface ModuleLoadingProps {
    isFullScreen?: boolean;
}

export default function ModuleLoading({ isFullScreen = false }: ModuleLoadingProps) {
    const classes = useClasses();

    return (
        <Box className={`module-loading ${isFullScreen && classes.fullScreen}`}>
            <Delay>
                <Grid container justifyContent="center">
                    <Box mt={`${!isFullScreen && "80px"}`}>
                        <CircularProgress size={80} color="primary" />
                    </Box>
                </Grid>
            </Delay>
        </Box>
    );
}
